import { RouteObject } from'react-router-dom';
import { CreateDisconnect } from './components/create/CreateDisconnect';

export const disconnectRoutes: RouteObject[] = [
 {
 path:'create/disconnect',
 element: <CreateDisconnect />,
 }
];
